export default __webpack_public_path__ + "static/media/maintenance_started_on.0f954ef2.svg";